import {
  YEAR_RECAP_ROUTE_NAME, YEAR_RECAP_ROUTE_PATH, YEAR_RECAP_PUBLIC_ROUTE_NAME, YEAR_RECAP_PUBLIC_ROUTE_PATH,
} from './constants'
import previewRoutes from './preview/previewRoutes'

export default [
  {
    path: YEAR_RECAP_ROUTE_PATH,
    name: YEAR_RECAP_ROUTE_NAME,
    meta: { title: 'Your year on AhaSlides' },
    component: () => import('./YearRecapPage.vue'),
  },
  {
    path: YEAR_RECAP_PUBLIC_ROUTE_PATH,
    name: YEAR_RECAP_PUBLIC_ROUTE_NAME,
    meta: { title: 'A year on AhaSlides' },
    component: () => import('./YearRecapPage.vue'),
  },
  ...previewRoutes,
]
